import { ReactElement } from "react";

import { Navigate, createFileRoute } from "@tanstack/react-router";

import { Queries } from "@/queries/Queries.ts";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index(): ReactElement {
  const me = Queries.user.useMe({});

  switch (me.userType) {
    case "admin":
      return <Navigate to="/admin" />;
    case "patient":
      return <Navigate to="/patient" />;
    case "practitioner":
      return <Navigate to="/patients" />;
  }
}
